import {
  configApiRef,
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';

const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scmIntegrationsApi',
  params: defineParams =>
    defineParams({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

export const apiModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scmIntegrationsApi],
});
